// API Configuration
// Force HTTPS in production to prevent mixed content errors
const rawApiUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8004'
export const API_BASE_URL = typeof window !== 'undefined' && window.location.protocol === 'https:'
  ? rawApiUrl.replace('http://', 'https://')
  : rawApiUrl

// Authentication
export const TOKEN_KEY = 'access_token'
export const REFRESH_TOKEN_KEY = 'refresh_token'
export const TOKEN_EXPIRY_KEY = 'token_expiry'

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'bgai_access_token',
  REFRESH_TOKEN: 'bgai_refresh_token',
  USER_PREFERENCES: 'bgai_user_preferences',
  THEME: 'bgai_theme',
} as const

// App Configuration
export const APP_CONFIG = {
  APP_NAME: 'CleverAct AI',
  APP_VERSION: '2.0.0',
  COMPANY_NAME: 'CleverAct AI Technologies',
  SUPPORT_EMAIL: 'support@cleveract.ai',
} as const

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
  ME: '/auth/me',
  
  // Chatbots
  CHATBOTS: '/chatbots',
  CHATBOT_BY_ID: (id: string) => `/chatbots/${id}`,
  CHATBOT_ANALYTICS: (id: string) => `/chatbots/${id}/analytics`,
  
  // Analytics
  ANALYTICS: '/analytics',
  ANALYTICS_CHATBOT: (id: string) => `/analytics/chatbot/${id}`,
  
  // Chat
  CHAT: '/chat',
  CHAT_HISTORY: '/chat/history',
  
  // Chat with Conversation Continuity
  CHAT_CONTINUE: '/chat/continue',
  CHAT_IDENTIFY: '/chat/identify',
  CHAT_VISITOR_HISTORY: (visitorId: string) => `/chat/visitor/${visitorId}/history`,
  
  // File Upload
  UPLOAD: '/upload',
  UPLOAD_BATCH: '/upload-batch',
  UPLOAD_URLS: '/upload-urls',
  UPLOAD_TEXT: '/upload-text',
  
  // System
  HEALTH: '/health',
  COLLECTION_INFO: '/collection-info',
} as const

// UI Constants
export const UI_CONFIG = {
  SIDEBAR_WIDTH: 240,
  HEADER_HEIGHT: 64,
  MOBILE_BREAKPOINT: 768,
  SIDEBAR_COLLAPSED_WIDTH: 64,
} as const

// File Upload
export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: [
    'text/csv',
    'application/pdf',
    'text/plain',
    'application/json',
  ],
  MAX_FILES: 50,
} as const

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const

// Theme
export const THEME_CONFIG = {
  DEFAULT_THEME: 'light',
  STORAGE_KEY: 'bgai-theme',
} as const// Build trigger 1769612561
